export enum SchemaTypeEnum {
    Article = 'article',
    Product = 'product',
    Faq = 'faq',
}
